import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { SummaryNotes } from '@authority-labs/api-interfaces';

@Component({
  selector: 'authority-labs-summary-notes',
  templateUrl: './summary-notes.component.html',
  styleUrls: ['./summary-notes.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SummaryNotesComponent implements OnChanges {
  @Input() summaryNotes: SummaryNotes[] = [];
  @Input() root = false;

  notesToDisplay: SummaryNotes[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    const notes: SummaryNotes[] = changes?.summaryNotes?.currentValue || [];
    this.notesToDisplay = notes.filter((x) => x.addNotesToReport);
  }
}
